import React from 'react';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { HeroSection } from './components/sections/HeroSection';
import { TrustBadgesSection } from './components/sections/TrustBadgesSection';
import { StatsSection } from './components/sections/StatsSection';
import { ServicesSection } from './components/sections/ServicesSection';
import { ExperienceSection } from './components/sections/ExperienceSection';
import { ProjectsSection } from './components/sections/ProjectsSection';
import { ContactSection } from './components/sections/ContactSection';
import { useMenu } from './hooks/useMenu';

const App: React.FC = () => {
  const { isMenuOpen, toggleMenu, closeMenu } = useMenu();

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800">
      <Navbar
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        closeMenu={closeMenu}
      />

      <main>
        <HeroSection />
        <TrustBadgesSection />
        <StatsSection />
        <ServicesSection />
        <ExperienceSection />
        <ProjectsSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
};

export default App;
